module.exports = __webpack_public_path__ + "static/media/slider1-3.402b3172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/slider1-3.jpg
// module id = 477
// module chunks = 0